export default __webpack_public_path__ + "static/media/ab2.f040e6bc.png";